import { type NodeProps } from '@xyflow/react';
import { css } from 'aphrodite';
import * as Api from '@ViewModels';
import { accessibilityStyles } from '../../../styles/styles';
import { AutomationTriggerIcon } from '../../../components/svgs/icons/AutomationTriggerIcon';
import { type BaseNodeData } from '../types';
import { BaseNode } from './BaseNode';
import { nodeStyles } from './styles';
import { getTriggerLabel, normalizeTriggerType } from '../utils/convertTemplateToFlow';

export function TriggerNode({ data, selected }: NodeProps) {
	const nodeData = data as BaseNodeData & {
		targetPosition?: any;
		sourcePosition?: any;
		automationTrigger?: Api.IAutomationTrigger;
	};
	const trigger = nodeData.automationTrigger;
	const normalizedTrigger = trigger ? normalizeTriggerType(trigger) : undefined;
	const triggerLabel = trigger ? getTriggerLabel(trigger) : nodeData.label || 'Trigger';

	return (
		<div role='button' tabIndex={0} aria-label={`Trigger: ${triggerLabel}`} aria-describedby='trigger-description'>
			<BaseNode
				data={{
					...nodeData,
					label: triggerLabel,
				}}
				selected={Boolean(selected)}
				containerStyle={nodeStyles.triggerContainer}
				showTargetHandle={false}
				targetPosition={nodeData.targetPosition}
				sourcePosition={nodeData.sourcePosition}
				icon={
					normalizedTrigger ? (
						<AutomationTriggerIcon trigger={normalizedTrigger} />
					) : (
						<svg width='16' height='16' viewBox='0 0 16 16' fill='none' aria-hidden='true'>
							<circle cx='8' cy='8' r='6' fill='#818cf8' />
							<path d='M8 4v4l3 2' stroke='white' strokeWidth='1.5' strokeLinecap='round' />
						</svg>
					)
				}
			/>
			<span id='trigger-description' className={css(accessibilityStyles.srOnly)}>
				Starting point of the automation flow
			</span>
		</div>
	);
}
